window.TmPaymentConfig = (function () {
  var ALL_MONTHS = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  var COMMISSION_BY_MONTH = {
    3: 19,
    4: 22,
    5: 25,
    6: 28,
    7: 31,
    8: 34,
    9: 37,
    10: 40,
    11: 43,
    12: 46
  };

  var BANKS = {
    akbank: { label: 'Akbank', months: ALL_MONTHS.slice() },
    yapikredi: { label: 'Yapı Kredi', months: ALL_MONTHS.slice() },
    vakif: { label: 'Vakıfbank', months: ALL_MONTHS.slice() },
    other: { label: 'Diğer bankalar', months: ALL_MONTHS.slice() }
  };

  function commission(months) {
    return COMMISSION_BY_MONTH[months] || 0;
  }

  function eachPlan(fn) {
    Object.keys(BANKS).forEach(function (bankKey) {
      var bank = BANKS[bankKey];
      bank.months.forEach(function (months) {
        fn({
          bankKey: bankKey,
          bankLabel: bank.label,
          months: months,
          commission: commission(months)
        });
      });
    });
  }

  function tableGroups() {
    return [
      {
        title: 'Mail Order — Taksit oranları (işletme kartları hariç)',
        months: ALL_MONTHS.slice()
      }
    ];
  }

  function monthsForBank(bankKey) {
    return (BANKS[bankKey] && BANKS[bankKey].months) || [];
  }

  function bankLabel(bankKey) {
    return (BANKS[bankKey] && BANKS[bankKey].label) || bankKey;
  }

  // Upcharge fee option labels — admin'de fee label'ları buna uygun olmalı
  var FEE_LABELS = {
    site: 'Komisyon Site',
    mo3: 'Komisyon Taksit 3',
    mo4: 'Komisyon Taksit 4',
    mo5: 'Komisyon Taksit 5',
    mo6: 'Komisyon Taksit 6',
    mo7: 'Komisyon Taksit 7',
    mo8: 'Komisyon Taksit 8',
    mo9: 'Komisyon Taksit 9',
    mo10: 'Komisyon Taksit 10',
    mo11: 'Komisyon Taksit 11',
    mo12: 'Komisyon Taksit 12'
  };

  function feeKeyForMailOrder(months) {
    return 'mo' + months;
  }

  var SINGLE_QR_COMM = 7;

  function calcQrTotal(net) {
    return Math.ceil(net / (1 - SINGLE_QR_COMM / 100) / 50) * 50;
  }

  return {
    GATE_ENABLED: false,
    MIN_INSTALLMENT: 20000,
    SINGLE_SITE_COMM: 12,
    SINGLE_QR_COMM: SINGLE_QR_COMM,
    calcQrTotal: calcQrTotal,
    BANKS: BANKS,
    COMMISSION_BY_MONTH: COMMISSION_BY_MONTH,
    FEE_LABELS: FEE_LABELS,
    commission: commission,
    eachPlan: eachPlan,
    tableGroups: tableGroups,
    monthsForBank: monthsForBank,
    bankLabel: bankLabel,
    feeKeyForMailOrder: feeKeyForMailOrder
  };
})();
